var _ = require("underscore");

exports.paragraph = function(transform) {
    function transformElement(element) {
        if (element.children) {
            var children = _.map(element.children, transformElement);
            element = _.extend(element, {children: children});
        }
        
        if (element.type === "paragraph") {
            element = transform(element);
        }
        
        return element;
    }
    return transformElement;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mammoth-style/lib/transforms.js
// module id = 1980
// module chunks = 0